import script from "./MettingOngoing.vue?vue&type=script&setup=true&lang=js"
export * from "./MettingOngoing.vue?vue&type=script&setup=true&lang=js"

import "./MettingOngoing.vue?vue&type=style&index=0&id=1e2a08ee&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e2a08ee"]])

export default __exports__